export default __webpack_public_path__ + "1_login_mobile.png";